import { PPGDerivedDataGroup } from "../../../api";

/**
 * `measurement_type` of the whole-measurement mean, per PPG-derived data group.
 *
 * A group carries one row per aggregation function (mean / std / min / max /
 * ...), all sharing a `measurement_datetime`, so the group alone does not
 * identify a value — reading "the" HR or SpO2 of a measurement means selecting
 * this row.
 *
 * Kept in its own module rather than alongside `DerivedData`: consumers include
 * mock fixtures and leaf extractors that must not pull the model's dependency
 * graph in behind two string constants.
 */
export const DERIVED_MEAN_TYPE = {
  [PPGDerivedDataGroup.hr]: "HR: mean",
  [PPGDerivedDataGroup.spo2]: "SpO2: mean",
} as const;
